
import React, { useState, useEffect } from 'react';
import { Globe, ShieldCheck, Users, Activity, Loader2 } from 'lucide-react';

export const CollaborationBar: React.FC = () => {
  const [syncing, setSyncing] = useState(false);
  const [onlineUsers] = useState([
    { name: 'J. Smith', role: 'Superintendent', status: 'Viewing Site Log' },
    { name: 'A. Chen', role: 'Cost Engineer', status: 'Reviewing EAC' }
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSyncing(true);
      setTimeout(() => setSyncing(false), 2000);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-8 py-4 px-10 bg-white border-b border-zinc-100 print:hidden">
      <div className="flex items-center gap-2">
        {syncing ? (
          <div className="flex items-center gap-2 text-zinc-400">
            <Loader2 size={12} className="animate-spin" />
            <span className="text-[8px] font-black uppercase tracking-[0.2em]">Syncing via Cloudflare Edge</span>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-emerald-500">
            <Globe size={12} />
            <span className="text-[8px] font-black uppercase tracking-[0.2em]">Edge Node: Optimized</span>
          </div>
        )}
      </div>

      <div className="h-4 w-[1px] bg-zinc-100"></div>

      <div className="flex items-center gap-4">
        <div className="flex -space-x-3">
          {onlineUsers.map((u, i) => (
            <div key={i} className="w-6 h-6 rounded-full bg-zinc-900 border-2 border-white flex items-center justify-center text-[8px] font-black text-white relative group cursor-help">
              {u.name[0]}
              <div className="absolute top-8 left-0 hidden group-hover:block z-[100] bg-black text-white p-3 rounded-xl shadow-2xl min-w-[150px] animate-in fade-in zoom-in-95">
                <div className="text-[9px] font-black uppercase tracking-widest border-b border-zinc-800 pb-1 mb-1">{u.name}</div>
                <div className="text-[8px] text-zinc-400 font-bold uppercase">{u.role}</div>
                <div className="text-[8px] text-emerald-400 mt-2 italic">{u.status}</div>
              </div>
            </div>
          ))}
          <div className="w-6 h-6 rounded-full bg-zinc-100 border-2 border-white flex items-center justify-center text-[8px] font-black text-zinc-400">+1</div>
        </div>
        <span className="text-[8px] font-black uppercase tracking-widest text-zinc-400">Stakeholder Presence</span>
      </div>

      <div className="ml-auto flex items-center gap-4">
        <div className="flex items-center gap-2 px-3 py-1 bg-zinc-50 rounded-lg">
           <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></div>
           <span className="text-[8px] font-black uppercase tracking-widest text-zinc-500">D1 SQL Secured</span>
        </div>
      </div>
    </div>
  );
};
